module.exports = __webpack_public_path__ + "img/space-stock.27c0ef72.png";